import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [menuActive, setMenuActive] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleNavClick = () => {
    // Close mobile menu
    setMenuActive(false);

    // Scroll to top
    window.scrollTo(0, 0);
  };

  return (
    <header>
      <div className="container">
        <nav className="navbar">
          <Link to="/" className="logo" onClick={handleNavClick}>
            <img src="/images/logo.png" alt="Zanify Technologies" />
          </Link>
          <ul className={`nav-links ${menuActive ? 'active' : ''}`}>
            <li><Link to="/" className={isActive('/')} onClick={handleNavClick}>Home</Link></li>
            <li><Link to="/services" className={isActive('/services')} onClick={handleNavClick}>Services</Link></li>
            <li><Link to="/portfolio" className={isActive('/portfolio')} onClick={handleNavClick}>Our Work</Link></li>
            <li><Link to="/about" className={isActive('/about')} onClick={handleNavClick}>About Us</Link></li>
            <li><Link to="/contact" className={isActive('/contact')} onClick={handleNavClick}>Contact</Link></li>
          </ul>
          <div className="mobile-menu" onClick={toggleMenu}>
            <i className="fas fa-bars"></i>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;